import { Col, Row } from "react-bootstrap";
import type { RangeOption } from "../../../constants/epicLeaderboard";
import type { PkMilestones } from "../../../types/playerPk";
import { formatEtDate, formatEtDateTime } from "../../../utils/etDate";
import PlayerLink from "../../common/PlayerLink";
import PkStatTile from "./PkStatTile";
import "../../epicLeaderboard/epicLeaderboard.css";
import "./pk.css";

type Props = {
  milestones: PkMilestones;
  range: RangeOption;
};

// All time; the selected range doesn't apply here.
const MilestonesSection = ({ milestones, range }: Props) => {
  const link = (name: string) => (
    <PlayerLink className="pk-link" player={name} range={range} tab="pk" />
  );

  return (
    <>
      <Row className="g-3">
        <Col xs={12} md={4}>
          <PkStatTile
            label="First recorded"
            valueClassName="pk-tile-name"
            value={formatEtDateTime(milestones.firstSeenEt)}
          />
        </Col>
        <Col xs={12} md={4}>
          <PkStatTile
            label="First kill"
            valueClassName="pk-tile-name"
            value={
              milestones.firstKill ? link(milestones.firstKill.victim) : "-"
            }
            sub={
              milestones.firstKill
                ? formatEtDateTime(milestones.firstKill.dateEt)
                : "No kills recorded"
            }
          />
        </Col>
        <Col xs={12} md={4}>
          <PkStatTile
            label="First death"
            valueClassName="pk-tile-name"
            value={
              milestones.firstDeath ? link(milestones.firstDeath.killer) : "-"
            }
            sub={
              milestones.firstDeath
                ? formatEtDateTime(milestones.firstDeath.dateEt)
                : "No deaths recorded"
            }
          />
        </Col>
      </Row>
      {milestones.killMilestones.length > 0 && (
        <div className="pk-card mt-3">
          <div className="pk-subtitle">Kill milestones</div>
          <ul className="pk-milestone-list">
            {milestones.killMilestones.map((m) => (
              <li key={m.n}>
                <span className="pk-milestone-n">
                  #{m.n.toLocaleString()}
                </span>
                <span className="pk-wrap-anywhere">{link(m.victim)}</span>
                <span className="epic-lb-muted">
                  {formatEtDateTime(m.dateEt)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="player-muted-note mt-2">
        Records start {formatEtDate(milestones.dataStartsEt)}.
      </div>
    </>
  );
};

export default MilestonesSection;
